import type { RouteObject } from 'react-router';
import { AiServicesPage } from './pages/ai-services-page';
import { AiServiceDetailPage } from './pages/ai-service-detail-page';

export const aiServicesRoutes: RouteObject[] = [
  { path: 'ai-services', element: <AiServicesPage /> },
  { path: 'ai-services/:serviceId', element: <AiServiceDetailPage /> },
];
